var React = require('react');

function IconCompany (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 0a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h6v-5a3 3 0 0 1 6 0v5h6a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3Zm1 15c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-2Zm7-1h2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1Zm5 1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-2ZM5 6h2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1Zm5 1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1V7Zm7-1h2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1Z","fill":"currentColor"}));
}

IconCompany.defaultProps = {"fill":"none","viewBox":"0 0 24 32"};

module.exports = IconCompany;

IconCompany.default = IconCompany;
